module.exports = __webpack_public_path__ + "static/img/22.6c8c5b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/22.png
// module id = gDWh
// module chunks = 1